import { render, staticRenderFns } from "./CombinationGoods.vue?vue&type=template&id=0a14e758&scoped=true"
import script from "./CombinationGoods.vue?vue&type=script&lang=js"
export * from "./CombinationGoods.vue?vue&type=script&lang=js"
import style0 from "./CombinationGoods.vue?vue&type=style&index=0&id=0a14e758&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a14e758",
  null
  
)

export default component.exports